// src/services/tripService.ts
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

// Custom GraphQL mutation for deleting trip and its photos
const deleteTripWithAuth = /* GraphQL */ `
  mutation DeleteTripWithAuth($tripId: ID!) {
    deleteTripWithAuth(tripId: $tripId)
  }
`;

export const deleteTripAndAssociatedPhotos = async (tripId: string): Promise<boolean> => {
  try {
    // Call the GraphQL mutation directly using the client
    await client.graphql({
      query: deleteTripWithAuth,
      variables: { tripId },
      authMode: "userPool"
    });
    
    // Handle the response without trying to access the data property
    // We're just returning success if we didn't throw an exception
    return true;
  } catch (error) {
    console.error('Error deleting trip and photos:', error);
    throw error;
  }
};